import React, { Component } from 'react';
import { Container, Col, Row } from 'react-grid-system';
import PropTypes from 'prop-types';
import DateSelect from './DateSelect';
import FilterIcon from './FilterIcon';
import Label from '../../../components/shared/Label';
import FavouritesToggle from './FavouritesToggle';
import LiveToggle from './LiveToggle';
import Divisor from '../../../components/shared/Divisor';
import { FilterSportsWrapper, WrapperAll, RightWrapper } from './styles';
import { EVENT_FRAME1_NAME } from '../../../components/adv/Frame1Mobile';

class FilterBar extends Component {
  handleAllSportFilterChange = () => {
    document.dispatchEvent(new Event(EVENT_FRAME1_NAME));
    if (!this.props.allSportsFilter) {
      this.props.actions.allSportsFilter(!this.props.allSportsFilter);
      if (process.env.REACT_APP_SITE !== 'corriere') {
        window.omniture.trkEventMc(`Matchcenter filtro ${this.props.dictionary.allSport}`);
      }
    }
  };

  handleSportMapFilterChange = (filterState, id) => {
    this.props.actions.sportFilter(id, filterState);
    document.dispatchEvent(new Event(EVENT_FRAME1_NAME));
  };

  switchIcon = () => {
    let site = '';
    if (process.env.REACT_APP_SITE === 'corriere') {
      site = '-corr';
    }
    return site;
  };

  renderDateDropdown = () => (
    <Col lg={2} md={6} sm={6} xs={6} style={{ overflow: 'visible', paddingRight: 0, paddingLeft: this.props.isMobile ? '12px' : '0px' }}>
      <DateSelect
        actions={this.props.actions}
        dictionary={this.props.dictionary.dropdown}
        filterLive={this.props.filterLive}
        filterDate={this.props.filterDate}
      />
    </Col>
  );

  renderRightFilters = () => (
    <Col lg={3} md={6} sm={6} xs={6} style={{ paddingLeft: 0, paddingRight: this.props.isMobile ? '18px' : '0px' }}>
      <RightWrapper>
        <LiveToggle
          liveChange={this.props.actions.filterLive}
          dictionary={this.props.dictionary}
          filterDate={this.props.filterDate}
          liveCounter={this.props.liveCounter}
        />
        <FavouritesToggle
          favouritesCounter={this.props.favouritesCounter}
          actions={this.props.actions}
          location={this.props.location}
        />
      </RightWrapper>
    </Col>
  );

  renderLabelFilter() {
    const dc = this.props.dictionary;
    return (
      <Label label={dc.filterTitle} weight="normal" color="black" size={1} />
    );
  }

  render() {
    const sportLabelArray = this.props.availableSports;
    const dc = this.props.dictionary;
    const { isMobile } = this.props;
    return (
      <Container
        fluid
        style={{
          height: isMobile ? '6em' : '2em',
          marginTop: isMobile ? '1em' : '0em',
          marginBottom: isMobile ? '1em' : '1.9em',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Divisor
          width="104.8%"
          height="1px"
          color="borderColor"
          top="49px"
          left="-10px"
        />
        <Row style={{ alignItems: 'center', marginLeft: 0, marginRight: 0 }}>
          {this.renderDateDropdown()}
          {isMobile && this.renderRightFilters()}
          <Col lg={7} md={12} sm={12} xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
            {(process.env.REACT_APP_SITE !== 'fcinter' && process.env.REACT_APP_SITE !== 'calcionapoli1926' && process.env.REACT_APP_SITE !== 'forzaroma') &&
              <FilterSportsWrapper>
                {!isMobile && this.renderLabelFilter()}
                <WrapperAll onClick={this.handleAllSportFilterChange}>
                  <Label
                    label={dc.allSport}
                    color={this.props.allSportsFilter ? 'selectedColor' : 'black'}
                    size={1}
                    withCursor
                    isTitleNarrowMedium
                  />
                </WrapperAll>
                {sportLabelArray && sportLabelArray.size > 0 && sportLabelArray.map((filter, id) => {
                  const sportName = filter.get('name');
                  if (process.env.REACT_APP_SITE === 'corriere' && sportName === 'basket') {
                    return '';
                  }
                  return (
                    <FilterIcon
                      iconClass={`icon-matchcenter-${filter.get('name')}${this.switchIcon()}`}
                      isAvailable={filter.get('isAvailable')}
                      isSelected={filter.get('isSelected')}
                      sportId={filter.get('id')}
                      key={id}
                      changeSportFilter={this.handleSportMapFilterChange}
                      isMobile={isMobile}
                      sportName={filter.get('name')}
                    />
                  );
                })
                }
              </FilterSportsWrapper>
            }
          </Col>
          {!isMobile && this.renderRightFilters()}
        </Row>
      </Container>
    );
  }
}

FilterBar.propTypes = {
  availableSports: PropTypes.any,
  favouritesCounter: PropTypes.number,
  actions: PropTypes.any,
  location: PropTypes.any,
  dictionary: PropTypes.any,
  filterDate: PropTypes.any,
  filterLive: PropTypes.any,
  allSportsFilter: PropTypes.any,
  isMobile: PropTypes.any,
  liveCounter: PropTypes.any,
};

export default FilterBar;
